// NikoNiko Ceramic Studio - Main JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Initialize theme
  initTheme();
  
  // Spanish URL routing
  initSpanishRouting();
  
  // Cart functionality
  initCart();
  
  // Mobile menu
  initMobileMenu();
  
  // Newsletter popup
  initNewsletterPopup();
  
  // Wishlist
  initWishlist();
  
  // Product filters
  initProductFilters();
  
  // Animations
  initAnimations();
});

function initTheme() {
  const designVariant = window.theme?.settings?.designVariant || 'variant-a';
  document.body.classList.add(designVariant);
  
  // Load saved theme preference
  const savedVariant = localStorage.getItem('theme-variant');
  if (savedVariant && savedVariant !== designVariant) {
    document.body.classList.remove(designVariant);
    document.body.classList.add(savedVariant);
  }
}

function initSpanishRouting() {
  // Handle Spanish URL redirects
  const currentPath = window.location.pathname;
  const spanishRoutes = window.spanishRoutes || {};

  // Check if we need to redirect (except for root/home)
  Object.keys(spanishRoutes).forEach(spanishPath => {
    if (currentPath === spanishPath && spanishPath !== '/inicio') {
      window.location.href = spanishRoutes[spanishPath];
    }
  });

  // Update navigation links to use Spanish URLs (except home - keep as /)
  document.querySelectorAll('a[href]').forEach(link => {
    const href = link.getAttribute('href');
    Object.keys(spanishRoutes).forEach(spanishPath => {
      // Skip home route - don't change / to /inicio
      if (spanishPath === '/inicio') return;
      if (spanishRoutes[spanishPath] === href) {
        link.setAttribute('href', spanishPath);
      }
    });
  });
}

function initCart() {
  // Add to cart buttons
  document.addEventListener('click', async function(e) {
    if (e.target.matches('[data-add-to-cart]')) {
      e.preventDefault();
      const button = e.target;
      const variantId = button.dataset.variantId;
      const quantity = button.dataset.quantity || 1;
      
      button.disabled = true;
      button.textContent = 'Agregando...';
      
      try {
        await addToCart(variantId, quantity);
        updateCartUI();
        showCartNotification();
      } catch (error) {
        console.error('Error adding to cart:', error);
        button.textContent = 'Error';
      } finally {
        setTimeout(() => {
          button.disabled = false;
          button.textContent = window.theme.strings.addToCart;
        }, 1000);
      }
    }
  });
  
  // Cart drawer toggle
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  
  if (cartToggle && cartDrawer) {
    cartToggle.addEventListener('click', () => {
      cartDrawer.classList.toggle('open');
      document.body.classList.toggle('cart-drawer-open');
    });
  }
}

async function addToCart(variantId, quantity = 1) {
  const formData = {
    items: [{
      id: variantId,
      quantity: parseInt(quantity)
    }]
  };
  
  const response = await fetch(window.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(formData)
  });
  
  if (!response.ok) {
    throw new Error('Failed to add to cart');
  }
  
  return response.json();
}

function updateCartUI() {
  // Update cart count
  fetch(window.routes.cart_url + '.js')
    .then(response => response.json())
    .then(cart => {
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
      });
    });
}

function showCartNotification() {
  const notification = document.createElement('div');
  notification.className = 'fixed top-4 right-4 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg z-50 animate-slide-up';
  notification.textContent = '¡Producto agregado al carrito!';
  document.body.appendChild(notification);
  
  setTimeout(() => {
    notification.remove();
  }, 3000);
}

function initMobileMenu() {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
      menuToggle.classList.toggle('active');
      document.body.classList.toggle('mobile-menu-open');
    });
  }
}

function initNewsletterPopup() {
  if (!window.theme.settings.showPopupNewsletter) return;
  
  const popup = document.getElementById('newsletter-popup');
  const closeBtn = popup?.querySelector('.btn-close-popup');
  const delay = (window.theme.settings.popupDelaySeconds || 30) * 1000;
  
  if (popup && !localStorage.getItem('newsletter-popup-closed')) {
    setTimeout(() => {
      popup.classList.remove('hidden');
    }, delay);
    
    closeBtn?.addEventListener('click', () => {
      popup.classList.add('hidden');
      localStorage.setItem('newsletter-popup-closed', 'true');
    });
  }
}

function initWishlist() {
  const wishlistKey = 'nikoniko-wishlist';
  let wishlist = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
  
  // Update wishlist UI
  function updateWishlistUI() {
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = wishlist.length;
    });
    
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const productId = btn.dataset.productId;
      const isInWishlist = wishlist.includes(productId);
      btn.classList.toggle('active', isInWishlist);
      btn.setAttribute('aria-pressed', isInWishlist);
    });
  }
  
  // Toggle wishlist item
  document.addEventListener('click', function(e) {
    if (e.target.matches('[data-wishlist-toggle]')) {
      e.preventDefault();
      const productId = e.target.dataset.productId;
      const index = wishlist.indexOf(productId);
      
      if (index > -1) {
        wishlist.splice(index, 1);
      } else {
        wishlist.push(productId);
      }
      
      localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
      updateWishlistUI();
    }
  });
  
  updateWishlistUI();
}

function initProductFilters() {
  const filterForm = document.querySelector('[data-filter-form]');
  const productGrid = document.querySelector('[data-product-grid]');
  
  if (!filterForm || !productGrid) return;
  
  filterForm.addEventListener('change', function(e) {
    const formData = new FormData(filterForm);
    const params = new URLSearchParams(formData);
    
    // Update URL without reload
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({}, '', newUrl);
    
    // Fetch filtered products
    fetch(newUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-product-grid]');
        
        if (newGrid) {
          productGrid.innerHTML = newGrid.innerHTML;
          initAnimations();
        }
      });
  });
}

function initAnimations() {
  if (!window.theme.settings.enableAnimations) return;
  
  // Intersection Observer for fade-in animations
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-in');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });
  
  document.querySelectorAll('[data-animate]').forEach(el => {
    observer.observe(el);
  });
}

// Utility functions
function formatMoney(cents, format) {
  const money = (cents / 100).toFixed(2);
  if (window.theme.settings.currencyDisplay === 'mxn') {
    return `$${money} MXN`;
  }
  return `$${money} USD`;
}

// Export functions for use in other scripts
window.theme.cart = {
  addToCart,
  updateCartUI,
  formatMoney
};